/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Rights_Tools_Action_Menu_LabelInputs */



/**
* | output |
* | --- |
* | "Set for {tool}" |
*
* @param {Rights_Tools_Action_Menu_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_action_menu_label = /** @type {((inputs: Rights_Tools_Action_Menu_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Action_Menu_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Festlegen für ${i?.tool}`)
	return /** @type {LocalizedString} */ (`Set for ${i?.tool}`)
});